import { getTheBoolean, select } from 'src/store/selectors/utils'

const getHomeUnsubscribe = state => state.homeUnsubscribe
const selectFromHomeUnsubscribe = select(getHomeUnsubscribe)

export const selectHomeUnsubscribeRequested = selectFromHomeUnsubscribe(
  getTheBoolean('requested')
)
